import { IACDLEvent } from '../../../../../../../__legacy__/services/eventBus.service';

export const MarkingToolEditedEventType = Symbol('MARKING_TOOL_EDITED_EVENT');

export class MarkingToolEditedEvent implements IACDLEvent {
  readonly type: symbol = MarkingToolEditedEventType;
}
